<template>
    <div v-if="!getIsEmpty(isDeletable)">
        <div v-for="(item1, index1) in isDeletable" :key="index1" style="max-height: 90vh">
            <template v-if="getTypeof(item1) === 'string'">
                <p class="pb-0 mb-0">{{ item1 }}</p>
                <!-- ** Exercice clôturé -->
            </template>

            <template v-else-if="getTypeof(item1) === 'object'">
                <div
                    v-for="(item2, indexTitle) in Object.keys(item1)"
                    :key="indexTitle"
                    class="my-2 px-2"
                >
                    <h3 class="pt-2">{{ item2 }}</h3>
                    <!-- Contrôles ayant généré des écritures-->
                    <template
                        v-if="item1[item2] && item1[item2].length && getIsArray(item1[item2])"
                    >
                        <div v-for="(array2, index2) in item1[item2]" :key="index2" class="py-2">
                            <template v-if="getTypeof(array2) === 'string'">
                                <h4 class="pl-4">{{ array2 }}</h4>
                            </template>

                            <template v-else-if="!getIsArray(array2)">
                                <div v-for="(array3, index3) in Object.keys(array2)" :key="index3">
                                    <h4 class="pl-4">{{ array3 }}</h4>

                                    <template
                                        v-if="
                                            array2[array3] &&
                                            array2[array3].length &&
                                            getIsArray(array2[array3])
                                        "
                                    >
                                        <div
                                            v-for="(line, index4) in array2[array3]"
                                            :key="index4"
                                            class="pa-0 ma-0"
                                        >
                                            <p class="pl-8 pr-0 py-0 ma-0">{{ line }}</p>
                                        </div>
                                    </template>
                                </div>
                            </template>
                        </div>
                    </template>
                </div>
            </template>
        </div>
    </div>
</template>

<script lang="ts">
import { isArray, isEmpty } from "lodash";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";

@Component({})
export class AccountingPeriodIsDeletable extends Vue {
    @Prop({ default: null }) isDeletable: any;

    getTypeof(item: any) {
        return typeof item;
    }

    getIsArray(item: any) {
        return isArray(item);
    }

    getIsEmpty(item: any) {
        return isEmpty(item);
    }
}

export default toNative(AccountingPeriodIsDeletable);
</script>
